import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ChainsService } from '../services/chains.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class ChainListResolver implements Resolve<Observable<string>> {

    constructor(private chainsService: ChainsService) { }

    resolve() {
        return this.chainsService.getChains().catch(() => {
            return Observable.of('error');
        });
    }

}

